import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Riwayat from "@/pages/Riwayat";
import CutiIzin from "@/pages/CutiIzin";
import Lembur from "@/pages/Lembur";
import KlaimPengobatan from "@/pages/KlaimPengobatan";
import SlipGaji from "@/pages/SlipGaji";
import Persetujuan from "@/pages/Persetujuan";
import PerintahLembur from "@/pages/PerintahLembur";
import Profile from "@/pages/Profile";
import AdminPegawai from "@/pages/admin/AdminPegawai";
import AdminKomponenGaji from "@/pages/admin/AdminKomponenGaji";
import AdminReportGroups from "@/pages/admin/AdminReportGroups";
import AdminPayrollRun from "@/pages/admin/AdminPayrollRun";
import AdminLaporanPayroll from "@/pages/admin/AdminLaporanPayroll";
import AdminTidakTetap from "@/pages/admin/AdminTidakTetap";
import AdminBulkNominal from "@/pages/admin/AdminBulkNominal";
import AdminSummaryHarian from "@/pages/admin/AdminSummaryHarian";
import AdminOrganisasi from "@/pages/admin/AdminOrganisasi";
import AdminCostCenter from "@/pages/admin/AdminCostCenter";
import AdminKoperasi from "@/pages/admin/AdminKoperasi";
import AdminLokasi from "@/pages/admin/AdminLokasi";
import AdminJadwal from "@/pages/admin/AdminJadwal";
import AdminLaporan from "@/pages/admin/AdminLaporan";
import AdminLaporanLembur from "@/pages/admin/AdminLaporanLembur";
import AdminLaporanKlaim from "@/pages/admin/AdminLaporanKlaim";
import AdminSaldoCuti from "@/pages/admin/AdminSaldoCuti";
import AdminHolidays from "@/pages/admin/AdminHolidays";
import AdminKonfigurasi from "@/pages/admin/AdminKonfigurasi";
import AdminMasterKepegawaian from "@/pages/admin/AdminMasterKepegawaian";
import AdminSppdKonfigurasi from "@/pages/admin/AdminSppdKonfigurasi";
import PerintahSppd from "@/pages/PerintahSppd";
import VerifySppd from "@/pages/VerifySppd";
import AdminWfaBulk from "@/pages/admin/AdminWfaBulk";
import AdminPengajuan from "@/pages/admin/AdminPengajuan";
import KuotaLemburUnit from "@/pages/atasan/KuotaLemburUnit";
import BiodataMandiri from "@/pages/BiodataMandiri";
import AdminBiodata from "@/pages/admin/AdminBiodata";
import AdminDemografi from "@/pages/admin/AdminDemografi";
import { useAuth } from "@/context/AuthContext";

function LaporanAbsensiPage() {
  // Admin melihat rincian & rekap penuh dengan filter lintas unit + export.
  // Atasan Unit (asisten_manager/manager) melihat Summary Harian terfilter unitnya.
  const { user } = useAuth();
  if (user?.role === "admin") return <AdminLaporan />;
  return <AdminSummaryHarian />;
}

function HomePage() {
  // Admin & Payroll Admin adalah pengelola sistem — tidak melakukan check-in.
  // Arahkan ke halaman kerja utama mereka (Summary Harian / Payroll Run).
  const { user } = useAuth();
  if (user?.role === "admin") return <Navigate to="/admin/summary-harian" replace />;
  if (user?.role === "payroll_admin") return <Navigate to="/admin/payroll-run" replace />;
  return <Dashboard />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify/sppd/:nomor" element={<VerifySppd />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout><HomePage /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/riwayat"
              element={
                <ProtectedRoute>
                  <AppLayout><Riwayat /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuti-izin"
              element={
                <ProtectedRoute>
                  <AppLayout><CutiIzin /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lembur"
              element={
                <ProtectedRoute>
                  <AppLayout><Lembur /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/klaim"
              element={
                <ProtectedRoute>
                  <AppLayout><KlaimPengobatan /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/persetujuan"
              element={
                <ProtectedRoute>
                  <AppLayout><Persetujuan /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profil"
              element={
                <ProtectedRoute>
                  <AppLayout><Profile /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/perintah-lembur"
              element={
                <ProtectedRoute roles={["admin", "manager", "asisten_manager", "general_manager", "kepala_divisi", "direksi"]}>
                  <AppLayout><PerintahLembur /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/holidays"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminHolidays /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pengajuan"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminPengajuan /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pegawai"
              element={
                <ProtectedRoute roles={["admin", "payroll_admin"]}>
                  <AppLayout><AdminPegawai /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/slip-gaji"
              element={
                <ProtectedRoute>
                  <AppLayout><SlipGaji /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/komponen-tidak-tetap"
              element={
                <ProtectedRoute roles={["admin", "payroll_admin"]}>
                  <AppLayout><AdminTidakTetap /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/bulk-nominal"
              element={
                <ProtectedRoute roles={["admin", "payroll_admin"]}>
                  <AppLayout><AdminBulkNominal /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/summary-harian"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminSummaryHarian /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/payroll-run"
              element={
                <ProtectedRoute roles={["admin", "payroll_admin"]}>
                  <AppLayout><AdminPayrollRun /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/laporan-payroll"
              element={
                <ProtectedRoute roles={["admin", "payroll_admin"]}>
                  <AppLayout><AdminLaporanPayroll /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/komponen-gaji"
              element={
                <ProtectedRoute roles={["admin", "payroll_admin"]}>
                  <AppLayout><AdminKomponenGaji /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/organisasi"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminOrganisasi /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/report-groups"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminReportGroups /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/cost-center"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminCostCenter /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/koperasi"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminKoperasi /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/lokasi"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminLokasi /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/jadwal"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminJadwal /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/laporan"
              element={
                <ProtectedRoute roles={["admin", "asisten_manager", "manager"]}>
                  <AppLayout><LaporanAbsensiPage /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/laporan-lembur"
              element={
                <ProtectedRoute roles={["admin", "asisten_manager", "manager"]}>
                  <AppLayout><AdminLaporanLembur /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/atasan/kuota-lembur"
              element={
                <ProtectedRoute roles={["admin", "asisten_manager", "manager"]}>
                  <AppLayout><KuotaLemburUnit /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/laporan-klaim"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminLaporanKlaim /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/saldo-cuti"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminSaldoCuti /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/konfigurasi"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminKonfigurasi /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/master-kepegawaian"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminMasterKepegawaian /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/konfigurasi-sppd"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminSppdKonfigurasi /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/perintah-sppd"
              element={
                <ProtectedRoute>
                  <AppLayout><PerintahSppd /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/wfa-bulk"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminWfaBulk /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/biodata"
              element={
                <ProtectedRoute>
                  <AppLayout><BiodataMandiri /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/biodata"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminBiodata /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/demografi"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppLayout><AdminDemografi /></AppLayout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
